import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon,
  Icons
} from '@clientbase/clientbase-library'
import { Box, Stack, Typography } from '@mui/material'

import IconContainer from 'components/IconContainer/IconContainer'
import { Table } from 'components/Table'

import { formatMoney } from 'utils'

import { theme } from 'styles/theme'

import {
  renderItemBonus,
  renderItemTotal
} from '../../../ModalChargeDetail/components/Composition/Composition'
import { ModalInstallmentDetailContext } from '../../context'

export const compositionDetailMapper = (billingItems: any[]) => {
  return billingItems?.map((item) => ({
    item: item.product ? (
      <a
        target="_blank"
        href={`/planos/${item.product.uuid}`}
        style={{ all: 'unset' }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography>{item.product.name}</Typography>
          {item.product.total_cycles === 0 ? (
            <Icon icon="cached" colorSX={theme.palette.neutral[400]} />
          ) : item.product.total_cycles > 0 ? (
            <Typography color={theme.palette.neutral[400]} fontWeight={600}>
              ({item.product.total_cycles}x)
            </Typography>
          ) : null}
          <Icon icon="open" />
        </Stack>
      </a>
    ) : (
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography>{item.description || '-'}</Typography>
        <Icon icon="cached" colorSX={theme.palette.neutral[400]} />
      </Stack>
    ),
    amountUnit: formatMoney(item?.amount_unit) || '',
    bonus: renderItemBonus(item),
    quantity: Number(item?.quantity) || 1,
    amountBilled: renderItemTotal(item)
  }))
}

const cardTittle = (title: string, icon: Icons) => (
  <Stack direction="row" alignItems="center" gap={2}>
    <IconContainer icon={icon} size={2.5} />
    <Typography>{title}</Typography>
  </Stack>
)

const Composition: React.FC = () => {
  const { installment } = useContext(ModalInstallmentDetailContext)

  if (!installment.billing_items || installment.billing_items.length === 0) {
    return null
  }

  return (
    <Accordion
      defaultExpanded
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          margin: 0,
          backgroundColor: '#fff'
        }
      }}
    >
      <AccordionSummary aria-controls="composition-content" id="composition">
        {cardTittle('Composição do parcelamento', 'paid')}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          <Box maxHeight="200px" overflow="auto">
            <Table
              mobileCards
              header={[
                { id: 'item', label: 'Plano/Item' },
                { id: 'amountUnit', label: 'Valor' },
                { id: 'bonus', label: 'Bonificação' },
                { id: 'quantity', label: 'Qtd.' },
                { id: 'amountBilled', label: 'Total' }
              ]}
              hoverInRow
              rows={compositionDetailMapper(installment.billing_items)}
              select={{ useSelect: false }}
              hiddePagination
              hideLastRowSeparator
            />
          </Box>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default Composition
